// Schutz vor der Außenklick-Logik von Radix.
//
// Das Problem, im Build reproduziert: Sprechblase und Abdunklung der Tour
// hängen am <body>, nicht im Dialog. Für Radix ist damit jeder Zeiger, der
// dort landet, ein Klick NEBEN den Dialog — und ein Klick daneben schließt
// ihn. Wer im ISBN-Schritt die Übungs-ISBN markieren will, schließt also
// das Erfassungs-Formular. Danach ist der Anker weg, und die Blase
// strandet oben links in der Ecke.
//
// Die Lösung hängt an den Dialogen, nicht an der Tour: `onPointerDownOutside`
// und `onInteractOutside` werden abgewiesen, wenn der Zeiger in einem
// Tour-Element gelandet ist. Alles andere schließt weiterhin wie bisher —
// die drei Schließwege des Dialogs bleiben unangetastet.
//
// Bewusst NICHT gelöst über `pointer-events: none` auf der Blase: dann
// wären ihre eigenen Knöpfe („Weiter", ×) tot.
//
// DASSELBE GILT FÜR DAS SCAN-FENSTER (A5.1)
//
// Seit es in ein eigenes Portal am <body> gerendert wird, ist es für Radix
// ebenfalls „außerhalb" — und ein Tipp auf „Abbrechen" im Scanner schloss
// nicht nur die Kamera, sondern das ganze Erfassungs-Formular samt aller
// Eingaben. Gemessen im Prüfstand: Scanner zu, Sheet weg, Felder weg.
//
// Deshalb heißt die Funktion nicht mehr `faengtAussenklickAb`. Sie
// fängt jetzt zwei Dinge ab, die dasselbe gemeinsam haben: Sie hängen am
// <body> und gehören trotzdem zum Dialog davor.

/** Liegt das Ziel in der Sprechblase oder auf der Abdunklung der Tour? */
export function istTourElement(ziel: EventTarget | null): boolean {
  if (!(ziel instanceof Element)) return false;
  return ziel.closest('.driver-popover, .driver-overlay') !== null;
}

/** Liegt das Ziel im Scan-Fenster? */
export function istScanFenster(ziel: EventTarget | null): boolean {
  if (!(ziel instanceof Element)) return false;
  return ziel.closest('[data-tour="scan-fenster"]') !== null;
}

/**
 * Handler für Radix' `onPointerDownOutside` / `onInteractOutside`.
 *
 * Radix verpackt das echte Ereignis in `detail.originalEvent`; das Ziel
 * des CustomEvent selbst ist der Dialog, nicht das Angeklickte. Wer hier
 * `e.target` prüft, prüft das Falsche und wundert sich, dass der Schutz
 * nie greift.
 */
export function faengtAussenklickAb(
  e: CustomEvent<{ originalEvent?: Event }> | Event
): void {
  const detail = (e as CustomEvent<{ originalEvent?: Event }>).detail;
  const ziel = detail?.originalEvent?.target ?? null;
  if (istTourElement(ziel) || istScanFenster(ziel)) e.preventDefault();
}
